export default "__VITE_ASSET__C$5l9ZcM__"